// The payload is the deleted beneficiary's id, wrapped in an object: synapse's `DefaultPayload` requires
// `payload` to be a record (or an array of records), never a bare primitive.
export type BeneficiaryDeletedPayload = {
	beneficiaryId: number;
};

export type BeneficiaryDeletedAction = {
	type: 'BENEFICIARY_DELETED';
	payload: BeneficiaryDeletedPayload;
	facilityId: number;
};

export default (payload: BeneficiaryDeletedPayload, facilityId: number): BeneficiaryDeletedAction => ({
	type: 'BENEFICIARY_DELETED',
	payload,
	facilityId,
});
